import {Dropdown, DropdownItem} from "../components";
import React, {useEffect, useMemo, useRef, useState} from "react";
import DataEntryHeader from "../components/DataEntry/DataEntryHeader";
import moment from "moment";
import {useHistory, useParams} from "react-router-dom";
import {RouteWithId} from "../routes/types";
import {selectSelectedPagesForReport, setSelectedPagesForAnnualReport} from "./CreateReport/ReportingSlice";
import {useAppDispatch, useAppSelector} from "../store/hooks";
import ComparePlansWrapper from "./ComparePlansWrapper";
import {
    selectComparePlanPageActionMenuForReport,
    setComparePlanPageActionMenuForReport,
    setDifferenceBetweenPlansForReport
} from "../Plans/CompareScenarios/ComparePlansSlice";
import {resourcesApiClient} from "../Resources/ResourcesApiClient";
import {ReportConfig} from "./models/Reporting";


export const EditableComparePlansReport  = () => {

    const history = useHistory();
    const [comparePlan1SelectedId, setComparePlan1SelectedId] = useState<string>();
    const [comparePlan2SelectedId, setComparePlan2SelectedId] = useState<string | null>(null);
    const dispatch = useAppDispatch();
    const {id} = useParams<RouteWithId>();
    const selectedPagesForAnnualReportFromRedux = useAppSelector(selectSelectedPagesForReport);
    let selectedPagesForAnnualReport: ReportConfig;
    try {
        if (typeof selectedPagesForAnnualReportFromRedux === 'object' && selectedPagesForAnnualReportFromRedux !== null) {
            selectedPagesForAnnualReport = JSON.parse(JSON.stringify(selectedPagesForAnnualReportFromRedux));
        } else {
            throw new Error('selectedPagesForAnnualReportFromRedux is not a valid object');
        }
    } catch (e) {
        console.error('Failed to clone selectedPagesForAnnualReportFromRedux:', e);
        selectedPagesForAnnualReport = {} as ReportConfig;
    }
    const selectedDifferenceBetweenPlans = useAppSelector(selectComparePlanPageActionMenuForReport);
    const [showDifferenceBetweenPlansForReport , setShowDifferenceBetweenPlansForReport ] = useState<boolean>(selectedDifferenceBetweenPlans.showDifferenceBetweenPlansForReport);
    const memoizedShowDifferenceBetweenPlans = useMemo(() => showDifferenceBetweenPlansForReport, [showDifferenceBetweenPlansForReport]);
    const initialSelectedDifference = useRef(selectedDifferenceBetweenPlans.showDifferenceBetweenPlansForReport);
    const [disablePrimaryButton, setDisablePrimaryButton] = useState<boolean>(true);
    const idRef = useRef<string | undefined>(id);

    useEffect(() => {
        let isMounted = true;

        const fetchComparePlanIds = async () => {
            try {
                const comparePlanResponse = await resourcesApiClient.getComparePlan(id);

                    setComparePlan1SelectedId(prevId => {
                        if (prevId !== comparePlanResponse.comparePlan1SelectedId) {
                            return comparePlanResponse.comparePlan1SelectedId || id;
                        }
                        return prevId;
                    });
                    setComparePlan2SelectedId(prevId => {
                        if (prevId !== comparePlanResponse.comparePlan2SelectedId) {
                            return comparePlanResponse.comparePlan2SelectedId ?? null;
                        }
                        return prevId;
                    });

            } catch (error) {
                if (isMounted) {
                    setComparePlan2SelectedId(null);
                }
            }
        };

        fetchComparePlanIds();

    }, [id,comparePlan1SelectedId,comparePlan2SelectedId]);
    useEffect(() => {
        if (idRef.current !== id) {
            setShowDifferenceBetweenPlansForReport(false);
            dispatch(setDifferenceBetweenPlansForReport(false));
            dispatch(setComparePlanPageActionMenuForReport({
                showDifferenceBetweenPlansForReport: false
            }));
            idRef.current = id;
        }
    }, [id,selectedDifferenceBetweenPlans,dispatch]);
    const cancelEditComparePlansReport = () => {
        if (showDifferenceBetweenPlansForReport!== initialSelectedDifference.current) {
            setShowDifferenceBetweenPlansForReport(!showDifferenceBetweenPlansForReport);
            dispatch(setDifferenceBetweenPlansForReport(!showDifferenceBetweenPlansForReport));
            dispatch(setComparePlanPageActionMenuForReport({
                showDifferenceBetweenPlansForReport: !showDifferenceBetweenPlansForReport
            }));
        }
        history.push(`/Profile/${id}/ClientProfile/CreateReport`);
    };

    const toggleShowDeltaBetweenPlans = () => {
        setDisablePrimaryButton(false)
        setShowDifferenceBetweenPlansForReport(!showDifferenceBetweenPlansForReport);
        dispatch(setDifferenceBetweenPlansForReport(!showDifferenceBetweenPlansForReport));
        dispatch(setComparePlanPageActionMenuForReport({
            showDifferenceBetweenPlansForReport: !showDifferenceBetweenPlansForReport
        }));
    }

    const takeScreenShot = () => {
        const selectedPagesConfig: ReportConfig = {
            ...selectedPagesForAnnualReport,
            comparePlans: {
                ...selectedPagesForAnnualReport["comparePlans"],
                isEnabled: true,
            }
        };

        dispatch(setSelectedPagesForAnnualReport(selectedPagesConfig));
        history.push(`/Profile/${id}/ClientProfile/CreateReport`);

    }

    const component = (
        <Dropdown
            data-testid="show-delta-between-plans-for-report"
            className={"edit-family-tree-menu marginright-12"}
            panelWidth={240}
            rounded={false}
            buttonKind="secondary"
            aria-label="show-delta-between-plans-for-report"
            dropdownKind={"menu"}
            buttonSize={"medium"}
            buttonIcon={"only"}
            iconNameOpen={"menu_dots"}
            iconNameClose={"menu_dots"}
            alignRight={true}
        >
            <DropdownItem>
                <input
                    id="showDeltaBetweenPlansForReport"
                    name="show-delta-between-plans-for-report"
                    type="checkbox"
                    disabled={comparePlan2SelectedId === null}
                    aria-label="show-delta-between-plans-for-report"
                    key={"show-delta-between-plans-for-report"}
                    style={{marginRight: '10px'}}
                    onClick={toggleShowDeltaBetweenPlans}
                    checked={memoizedShowDifferenceBetweenPlans}
                />
                Show Difference between Plans
            </DropdownItem>
        </Dropdown>
    );

    return (
        <div>
            <DataEntryHeader
                title={"Compare Plans Report Preview"}
                primaryButtonText="SAVE"
                secondaryButtonText="Cancel"
                onPrimaryButtonClick={takeScreenShot}
                onSecondaryButtonClick={cancelEditComparePlansReport}
                isExtraHTMLElementRequired={true}
                extraHTMLElementComponent={component}
                SubtitleComponent={() => <span
                    className='holdings-subtitle'>{`As of ${moment().format('MM/DD/YYYY hh:mm A')}`}</span>}
                disablePrimaryButton={disablePrimaryButton}
            />

            {
                <ComparePlansWrapper showDeltaBetweenPlansForReport={showDifferenceBetweenPlansForReport}
                                     isEditPage={true}/>
            }

        </div>
    )
};